import React from 'react';
import { View, Text, Image } from 'react-native';

const Loader = require('./../../assets/loadingGif.gif');;

const LoaderComponent = ({styles}) => {
    return(
    <View>
        <Image source={Loader} style={styles}/>
    </View>
    )
}

export default LoaderComponent 